import request from '@/utils/request'

export function depts(data) {
  return request({
    url: 'admin/sys/dept',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: 'admin/sys/dept',
    method: 'delete',
    data
  })
}

export function get(id) {
  return request({
    url: 'admin/sys/dept/' + id,
    method: 'get'
  })
}

export function saveOrUpdate(data) {
  return request({
    url: 'admin/sys/dept',
    method: 'put',
    data
  })
}

export function getDeptAll() {
  return request({
    url: 'admin/sys/dept/getDeptList',
    method: 'POST'
  })
}
